import type { EstimatorIntroductionState } from './cost-to-build-client-ui-estimator-introduction.types';

export const ESTIMATOR_INTRODUCTION_INITIAL_STATE: EstimatorIntroductionState = {
    description: '',
    title: '',
};

export const areEstimatorIntroductionStatesEqual = (left: EstimatorIntroductionState, right: EstimatorIntroductionState) =>
    left.description === right.description && left.title === right.title;
